module.exports = __webpack_public_path__ + "static/media/shopping-cart.bc829077.svg";